import React from 'react';
import { IconLinkedIn, IconGithub, IconEmail, IconXTwitter } from './Icon.jsx';
import { getBookHref } from './misc.jsx';

export default function Contact(props: { forHomePage?: boolean }) {
  return (
    <section id="contact">
      <div className="content">
        {props.forHomePage && (
          <>
            <h3 className="section-subheading">CONTACT</h3>
            <h1 className="section-heading">Get in touch</h1>
          </>
        )}
        {!props.forHomePage && (
          <>
            <h3 className="section-subheading">GROW YOUR BUSINESS</h3>
            <h1 className="section-heading">Computing Den</h1>
          </>
        )}
        {!props.forHomePage && (
          <p className="brief">
            We are a software development agency specializing in creating complex web apps such as custom CRMs and ERPs.
            <br />
            See our{' '}
            <a href="https://computing-den.com" className="styled">
              portfolio and services
            </a>
            .
          </p>
        )}
        <div className="grid">
          <a className="item" href="https://www.linkedin.com/in/sean-shirazi" target="_blank">
            <IconLinkedIn />
          </a>
          <a className="item" href="mailto:sean@computing-den.com">
            <IconEmail />
          </a>
          <a className="item" href="https://x.com/SeanShirazi" target="_blank">
            <IconXTwitter />
          </a>
          <a className="item" href="https://github.com/computing-den" target="_blank">
            <IconGithub />
          </a>
        </div>
        <div className="button-container">
          <a className="item book-button inverse" href={getBookHref()}>
            SCHEDULE CONSULTATION
          </a>
        </div>
      </div>
    </section>
  );
}
